import styled from 'styled-components'

const Container = styled.div`
  padding: 15px 35px;
  margin: 0 auto;
  max-width: ${props => props.theme.container.maxWidth};
  width: 100%;
`

export default Container
